import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home.js";  // ✅ Explicit file extension added
import Stadiums from "./pages/Stadiums.js";  // ✅ Explicit file extension added

const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/stadiums" element={<Stadiums />} />
      </Routes>
    </div>
  );
};

export default App;
